import React, { Component } from 'react'
import { PermissionService } from 'services/PermissionService'
import { Permissions } from 'permissions'
import { MODAL_TYPES } from 'components/ModalFactory'
import { ModalFactory } from 'components/ModalFactory'
import { Card, Button, List } from 'antd'
import { activateSMS } from 'services/SmsActivationService'
import { getOverviewInfo, getConfiguration, getTemporaryAccessKey } from 'services/CeberusApiService'
import { BaseRequest } from 'models/request/BaseRequest'
import { ConfigurationRequest } from 'models/request/ConfigurationRequest'
import { Tenant } from 'models/Blip/Tenant'
import { Document } from 'models/Blip/Index'
import { TenantService } from 'connection/TenantService'
import { OverviewRequest } from 'models/request/OverviewRequest'
import { OverviewResponse } from 'models/response/OverviewResponse'
import { GridView } from 'models/GridView'
import { PushNotification } from 'utils/PushNotification'
import { AccessKeyRequest } from 'models/request/AccessKeyRequest'

const CONFIG_TOKEN_SMS = 'token';
const SMS_ACTIVATION = 'SMS Activation';
const CONFIG_URL_INFO_BLIP = 'urlinfobip';
const CONFIG_OWNER_SMS = 'sms.gw.msging.net';
const CONFIG_LARGE_ACCOUNT_SMS = 'largeaccount';
const CONFIG_PASSWORD_INFO_BLIP = 'senhainfobip';
const SMS_ACTIVATION_KEY_AUTH_EXPIRATION = 60000

const ListItem = List.Item
const ListItemMeta = List.Item.Meta

export class Sms extends Component<BaseRequest> {

  async componentDidMount() {
    await this.loadPage();
  }

  tenantSelected: Tenant;
  activateSMSRef: any;

  state = {
    isLoading: true,
    overviewResponse: new OverviewResponse(),
    configurations: [],
    editingRecord: {},
    currentModal: '',
    isModalLoading: false,
    hasSmsActivation: false,
    smsTokenConfig: {},
    smsLargeAccountConfig: new Document(),
    providerUrl: new Document(),
    providerAuthorization: new Document(),
    hasEditPermission: PermissionService.hasPermission(Permissions.Application_Channels_Sms_Add)
  }

  loadPage = async () : Promise<void> => {
    try {
      this.setState({ isLoading: true });
      this.tenantSelected = TenantService.getSelectedTenant();
      const overviewResponse = await this.getBotInfo();
      this.setState({ overviewResponse });
      await this.getConfiguration();
    } finally {
      this.setState({ isLoading: false });
    }
  }

  getTokenSms = (items: any) : any => {
    return items.find((config: any) => config.owner.Domain === CONFIG_OWNER_SMS && config.name.toLowerCase() === CONFIG_TOKEN_SMS && config.value);
  }

  getLargeAccountSms = (items: any): any => {
    console.log(items)
    return items.find((config: any) => config.owner.Domain === CONFIG_OWNER_SMS && config.name.toLowerCase() === CONFIG_LARGE_ACCOUNT_SMS && config.value);
  }

  getProviderUrl = (items: any) : any => {
    return items.find((config: any) => config.owner.Domain === CONFIG_OWNER_SMS && config.name.toLowerCase() === CONFIG_URL_INFO_BLIP && config.value);
  }

  getProviderAuthorization = (items: any) : any => {
    return items.find((config: any) => config.owner.Domain === CONFIG_OWNER_SMS && config.name.toLowerCase() === CONFIG_PASSWORD_INFO_BLIP && config.value);
  }

  getConfiguration = async () : Promise<void> => {
    try{
      const request = new ConfigurationRequest();
      request.BotIdentifier = this.props.BotIdentifier;
      request.ClusterName = this.tenantSelected.name;
      const configurations = await getConfiguration(request);
      this.setState({ configurations })
      this.setConfigurations();
    } catch (error) {
      PushNotification.httpError(error);
    }
  }

  setConfigurations = () : void => {
    const smsConfigurations = this.state.configurations.filter((config: any) => config.owner.Domain === CONFIG_OWNER_SMS);
    const providerUrl = this.getProviderUrl(smsConfigurations);
    const providerAuthorization = this.getProviderAuthorization(smsConfigurations);
    const smsTokenConfig = this.getTokenSms(smsConfigurations);
    const smsLargeAccountConfig = this.getLargeAccountSms(smsConfigurations);
    const hasSmsActivation = (smsLargeAccountConfig || smsTokenConfig) ? true : false;
    this.setState({ hasSmsActivation, smsTokenConfig, smsLargeAccountConfig, providerUrl, providerAuthorization });
  }

  getBotInfo = async () : Promise<OverviewResponse> => {
    try {
      const request = new OverviewRequest();
      request.BotIdentifier = this.props.BotIdentifier;
      request.ClusterName = this.tenantSelected.name;
      return await getOverviewInfo(request);
    } catch (error) {
      PushNotification.httpError(error);
    }
  }

  getItemList = () : Array<GridView> => {
    if (this.state.hasSmsActivation) {
      return [
        {
          title: 'Channel:',
          description: 'Active',
          visible: true
        },
        {
          title: 'Large Account:',
          description: this.state.smsLargeAccountConfig ? this.state.smsLargeAccountConfig.value : '',
          visible: this.state.smsLargeAccountConfig ? true : false
        },
        {
          title: 'Provider URL:',
          description: this.state.providerUrl ? this.state.providerUrl.value : '',
          visible: this.state.providerUrl ? true : false
        },
        {
          title: 'Provider Authorization:',
          description: this.state.providerAuthorization ? this.state.providerAuthorization.value : '',
          visible: this.state.providerAuthorization ? true : false
        }
      ]
    }

    return []
  }

  saveActivateSMSRef = (formRef: any) : void => {
    this.activateSMSRef = formRef;
  }

  handleActivateSMS = () : void => {
    this.setState({ isModalLoading: true });

    const form = this.activateSMSRef.props.form;

    form.validateFields(async (err, values) => {
      if (err) {
        this.setState({ isModalLoading: false });
        return
      }

      try {
        const organization = this.state.overviewResponse.Organization ? decodeURIComponent(this.state.overviewResponse.Organization.split('@')[0]) : '';
        const request = new AccessKeyRequest(this.state.overviewResponse.Identity, SMS_ACTIVATION, SMS_ACTIVATION_KEY_AUTH_EXPIRATION, this.tenantSelected.defaultCluster)
        const temporaryAuthorizationKey = await getTemporaryAccessKey(request)
        const authorization = temporaryAuthorizationKey.Key
        const response = await activateSMS({
          ...values,
          authorization,
          organization,
          cluster: this.tenantSelected.defaultCluster.toLowerCase()
        });

        form.resetFields();

        this.setState({ currentModal: '', editingRecord: {} });

        this.setState({ isModalLoading: false });

        if (response.status === 200) {
          PushNotification.success(response.data);
          this.loadPage();
        }else{
          PushNotification.error(response.data);
        }

      } catch (error) {
        PushNotification.httpError(error);
        throw error;
      } finally {
        this.setState({ isModalLoading: false });
      }
    })
  }

  handleModalVisibility = (type: string, visibility: boolean) : void => {
    this.setState({ currentModal: visibility ? type : '' });

    if (!visibility) {
      this.setState({ editingRecord: {} });
    }
  }

  render() {
    const itemList = this.getItemList();

    return (
      <div>
        <Card title={SMS_ACTIVATION} loading={this.state.isLoading}>
          {
            (this.state.hasSmsActivation)
              ? <List
                loading={this.state.isLoading}
                itemLayout="horizontal"
                dataSource={itemList}
                renderItem={item => item.visible ? (
                  <ListItem>
                    <ListItemMeta
                      title={item.title}
                      description={item.description}>
                    </ListItemMeta>
                  </ListItem>) : (<></>)}>
              </List>
              : <Button
                key="activateSms"
                type="primary"
                disabled={!this.state.hasEditPermission}
                onClick={() => this.handleModalVisibility(MODAL_TYPES.SMSActivation, true)}>
                Activate SMS
              </Button>
          }
        </Card>

        <ModalFactory
          wrappedComponentRef={this.saveActivateSMSRef}
          visible={this.state.currentModal === MODAL_TYPES.SMSActivation}
          onCancel={() => this.handleModalVisibility(MODAL_TYPES.SMSActivation, false)}
          onOk={this.handleActivateSMS}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
        />
      </div>
    )
  }
}
